var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"friend-button",on:{"click":_vm.toline}},[_c('img',{attrs:{"src":"/static/img/lp/campaign/lineCampaign202110/friend_btn.png"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-245483ef","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/partials/FriendButton.vue
// module id = null
// module chunks = 